<template>
  <main class="min-h-screen w-full bg-gray-100 p-4 space-y-4">

    <!-- HEADER -->
    <div class="flex items-center justify-between">
      <h1 class="text-2xl font-semibold text-gray-800">
        Mission, Vision & Values
      </h1>

      <button @click="openCreateModal"
        class="px-3 py-1.5 rounded bg-orange-500 text-white text-sm hover:bg-orange-600 transition">
        + Create Post
      </button>
    </div>

    <!-- POSTS LIST -->
    <PostLists :posts="mvPosts" :show-meta="false" media-width="40%" media-height="40%" @edit="openEditModal" />

    <!-- CREATE / EDIT MODAL -->
    <CreatePostModal :show="showModal" :postToEdit="postBeingEdited" @close="closeModal" @refresh="refreshPosts"
      :show-meta="false" />
  </main>
</template>

<script>
import { ref, watch } from "vue";
import PostLists from "../announcements/Posts/PostLists.vue";
import CreatePostModal from "../announcements/Modals/CreatePostModal.vue";

export default {
  name: "MissionVisionValuesCMS",

  components: {
    PostLists,
    CreatePostModal,
  },

  props: {
    passSectionItemPost: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  setup(props) {
    // Posts (Mission / Vision / Values)
    const mvPosts = ref([]);

    // Modal state
    const showModal = ref(false);
    const postBeingEdited = ref(null);

    // Sync posts from parent
    watch(
      () => props.passSectionItemPost,
      (newPosts) => {
        mvPosts.value = newPosts.map(post => ({ ...post }));
      },
      { immediate: true }
    );

    // Actions
    const openCreateModal = () => {
      postBeingEdited.value = null;
      showModal.value = true;
    };

    const openEditModal = (post) => {
      postBeingEdited.value = post;
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      postBeingEdited.value = null;
    };

    const refreshPosts = () => {
      closeModal();
      // optional: re-fetch from API if needed
    };

    return {
      mvPosts,
      showModal,
      postBeingEdited,
      openCreateModal,
      openEditModal,
      closeModal,
      refreshPosts,
    };
  },
};
</script>